// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"64e3057a","195":"9e4ce4e4","240":"8bf1a98f","256":"adce8bf3","561":"940dd4bc","598":"11beb86f","645":"28bfa215","720":"002ba4d5","761":"8e35ba00","807":"4ca67742","827":"1387ebab"}[chunkId] + ".chunk.css";
};